import React from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from 'Redux/LoggedUserSlice';
import { EMPLOYEE_ROLE_ID } from 'Constants/General';
import useTranslation from 'Hooks/useTranslation';
import DateCard from 'Components/DateCard';
import { DatesContainer, EmptyContainer } from './style';
import useFetch from './Hooks/useFetch';
import useAttendance from './Hooks/useAttendance';

export default function Dates({ course }) {
  const courseId = course?.id;
  const { dates, userCount } = useFetch(courseId);
  const { t2 } = useTranslation('CourseDetails');
  const { roleId } = useSelector(userSelector);
  const { sendToAttendance } = useAttendance();

  if (dates?.length === 0) {
    return <EmptyContainer>{t2('NoSessions')}</EmptyContainer>;
  }

  return (
    <DatesContainer>
      {dates &&
        dates.map((date, index) => (
          <DateCard
            key={index}
            dateInfo={date}
            isEmployee={roleId === EMPLOYEE_ROLE_ID}
            userCount={userCount}
            onClick={roleId !== EMPLOYEE_ROLE_ID ? () => sendToAttendance(date, courseId, course?.thumbnailKey) : null}
          />
        ))}
    </DatesContainer>
  );
}
